import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { useEffect, useState } from "react";
import axios from "axios";
import { useT } from "@/i18n";
import { API } from "@/lib/api";

export const tileGradient = {
  yellow: "from-lime-400 to-green-500",
  sky: "from-amber-300 to-orange-400",
  pink: "from-sky-300 to-blue-500",
  green: "from-rose-400 to-pink-500",
  purple: "from-violet-400 to-purple-600",
  indigo: "from-fuchsia-400 to-violet-600",
  orange: "from-yellow-300 to-amber-400",
};

export default function ModulesGrid() {
  const { lang } = useT();
  const [modules, setModules] = useState([]);
  useEffect(() => {
    axios.get(`${API}/modules`).then((r) => setModules(r.data.modules || [])).catch(() => setModules([]));
  }, []);
  const lastAlone = modules.length % 2 === 1;
  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-6 max-w-4xl mx-auto">
      {modules.map((m, idx) => (
        <motion.div
          key={m.id}
          className={lastAlone && idx === modules.length - 1 ? "col-span-2 mx-auto w-[calc(50%-0.375rem)] sm:w-[calc(50%-0.75rem)]" : ""}
          initial={{ opacity: 0, y: 24, scale: 0.95 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: idx * 0.07, type: "spring", stiffness: 140 }}
          whileHover={{ y: -6 }}
          whileTap={{ scale: 0.96 }}
        >
          <Link
            to={`/module/${m.id}`}
            data-testid={`module-card-${m.id}`}
            className={`glossy-tile group relative flex flex-col h-full bg-gradient-to-br ${tileGradient[m.color]} rounded-[2rem] p-2 sm:p-3 overflow-hidden`}
          >
            <Star className="absolute top-5 left-5 w-5 h-5 sm:w-7 sm:h-7 text-yellow-200 fill-yellow-200 sparkle" />
            <Star className="absolute top-10 right-6 w-4 h-4 sm:w-6 sm:h-6 text-yellow-200 fill-yellow-200 sparkle" style={{ animationDelay: "0.8s" }} />
            <div className="h-28 sm:h-44 flex items-center justify-center py-2">
              <img
                src={`/img/${m.id}.webp`}
                alt=""
                className="h-full w-auto object-contain drop-shadow-xl group-hover:scale-110 transition-transform duration-300"
              />
            </div>
            <div className="relative flex-1 bg-white/85 backdrop-blur-sm border-2 border-white rounded-[1.5rem] px-2 sm:px-4 py-2 sm:py-3 text-center shadow-inner">
              <h3 className="font-fredoka text-sm sm:text-2xl font-bold text-blue-950 leading-tight" data-testid={`module-title-${m.id}`}>
                {m.title?.[lang] || m.title?.es}
              </h3>
              <p className="mt-1 text-[11px] sm:text-base text-blue-900/80 font-semibold leading-snug">
                {m.subtitle?.[lang] || m.subtitle?.es}
              </p>
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  );
}
